
export default {
	name: 'App',
}
